<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <slot></slot>
      </div>
    </template>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title class="headline">
          <div
            class="text-none font-weight-bold subtitle-md-1 align-center d-flex"
          >
            <v-icon size="20" class="mr-2" color="#F2994A">
              fal fa-circle-exclamation
            </v-icon>
            <span
              class="text-uppercase"
              style="font-size: 20px; color: #f2994a"
            >
              <translate>Report</translate>
            </span>
          </div>
        </v-card-title>
        <v-card-text>
          <v-select
            v-model="category"
            :items="categoryList"
            :label="$gettext('Why do you want to report this?')"
            outlined
            hide-details="auto"
            :rules="emptyRules"
          >
            <template v-slot:selection="{ item }">
              <span class="text-capitalize">{{ item }}</span>
            </template>
            <template v-slot:item="{ item }">
              <span class="text-capitalize">{{ item }}</span>
            </template>
          </v-select>
        </v-card-text>
        <v-card-text>
          <v-textarea
            v-model="reason"
            outlined
            :rules="emptyRules"
            hide-details="auto"
            required
            :placeholder="$gettext('Type your message')"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            large
            @click="action(false)"
            style="background-color: #e2e2e2; color: rgba(0, 0, 0, 0.87)"
            class="font-weight-bold text-none elevation-0 mr-3"
          >
            <translate>Cancel</translate>
          </v-btn>
          <v-btn
            large
            type="submit"
            color="primary"
            style="color: #fff"
            @click.prevent="action(true)"
            class="font-weight-bold text-none elevation-0"
          >
            <translate>Send</translate>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
export default {
  props: {
    value: {},
  },
  data() {
    return {
      valid: true,
      dialog: false,
      categoryList: [],
      postList: [
        this.$gettext("misleading or scam"),
        this.$gettext("sexually inappropriate"),
        this.$gettext("offensive"),
        this.$gettext("violence"),
        this.$gettext("hate speech"),
        this.$gettext("prohibited content"),
        this.$gettext("spam"),
        this.$gettext("false news"),
        this.$gettext("other"),
      ],
      userList: [
        this.$gettext("pretending to be someone"),
        this.$gettext("fake account"),
        this.$gettext("fake name"),
        this.$gettext("posting inappropriate things"),
        this.$gettext("harassment or bullying"),
        this.$gettext("i can't access my account"),
        this.$gettext("i want to help"),
        this.$gettext("other"),
      ],
      category: null,
      reason: null,
      emptyRules: [(v) => !!v || this.$gettext("Field is required")],
    };
  },
  computed: {
    reportData() {
      return this.$store.state.report.reportData;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dialog = val;
      },
    },
    reportData: {
      immediate: true,
      handler(val) {
        if (val) {
          if (val.entityName && val.entityName === "user") {
            this.categoryList = this.userList;
          } else {
            this.categoryList = this.postList;
          }
        }
      },
    },
  },
  methods: {
    async action(val) {
      if (val) {
        if (this.$refs.form.validate()) {
          let data = { ...this.reportData };
          data.category = this.category;
          data.reason = this.reason;
          await this.$store.dispatch("reportRequest", data);

          // reset form
          this.category = null;
          this.reason = null;
          this.$refs.form.reset(); //reset model
          this.$refs.form.resetValidation(); // reset validate
          this.$emit("action", false); //off dialog
        }
      } else {
        this.$emit("action", false); //off dialog
      }
    },
  },
};
</script>